import { ApiResponse, TokenData, Checklist, VehicleStatus } from '../models';
import * as http from './http';
import ApiService from './service';

export class CheckListService extends ApiService {
  public async loadAllChecklist() {
    const url = `${this.apiDomain}/api/checklist`;

    const resposne = await http.get<ApiResponse<Checklist[]>>(url, this.store);
    return resposne?.data?.data;
  }
  public async updateChecklist(data: Checklist, id?: string) {
    const url = `${this.apiDomain}/api/checklist/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createChecklist(data: Checklist) {
    const url = `${this.apiDomain}/api/checklist`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteChecklist(id?: string) {
    const url = `${this.apiDomain}/api/checklist/${id}`;

    const response = await http.remove<ApiResponse<Checklist>>(url, this.store);
    return response.data;
  }
}
